export default [
  {
    path: "/estore",
    component: () => import("../layout/PageLayoutWithoutContainer.vue"),
    children: [
      {
        path: ":id",
        name: "eStore POC",
        component: () => import("@/views/EStorePOC/EStorePOC.vue")
      },
      {
        path: ":serviceId/:id",
        name: "eStore POC Service",
        component: () =>
          import("@/views/EStorePOC/EStorePOC.vue"),
        props: true
      },
    ]
  }
];
